export const dp_s2 = 'var(--dp_s2)';
export const dp_s4 = 'var(--dp_s4)';
export const dp_s8 = 'var(--dp_s8)';
export const dp_s12 = 'var(--dp_s12)';
export const dp_s16 = 'var(--dp_s16)';
export const dp_s24 = 'var(--dp_s24)';
export const dp_s32 = 'var(--dp_s32)';
export const dp_s40 = 'var(--dp_s40)';
export const dp_s48 = 'var(--dp_s48)';
export const dp_s64 = 'var(--dp_s64)';
export const dp_s80 = 'var(--dp_s80)';
export const dp_s96 = 'var(--dp_s96)';
